import { useEffect, useState } from "react";
import { apiFetch, useAuth } from "../context/AuthContext";

const B = "#2C1A0E";

export default function Admins() {
  const { user } = useAuth();
  const [admins,  setAdmins]  = useState([]);
  const [loading, setLoading] = useState(true);
  const [form,    setForm]    = useState({ email:"", name:"", role:"staff", password:"embroideary" });
  const [msg,     setMsg]     = useState({ type:"", text:"" });

  const load = () => {
    apiFetch("/api/admins")
      .then(r => r.json()).then(setAdmins).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const add = async e => {
    e.preventDefault(); setMsg({ type:"", text:"" });
    const r = await apiFetch("/api/admins", {
      method: "POST", body: JSON.stringify(form),
    });
    const d = await r.json();
    if (!r.ok) { setMsg({ type:"err", text: d.error }); return; }
    setMsg({ type:"ok", text:"Admin added!" });
    setForm({ email:"", name:"", role:"staff", password:"embroideary" });
    load();
  };

  const toggle = async (email, active) => {
    await apiFetch(`/api/admins/${email}`, {
      method: "PATCH", body: JSON.stringify({ active: !active }),
    });
    load();
  };

  const remove = async email => {
    if (!window.confirm(`Remove ${email}?`)) return;
    await apiFetch(`/api/admins/${email}`, { method: "DELETE" });
    load();
  };

  if (user?.role !== "owner") return (
    <div style={{ padding: 40 }}>
      <div style={{ background:"#FCE4D6", color:"#C00000",
                    padding:"16px 20px", borderRadius:10, fontSize:15 }}>
        🔐 Owner access required.
      </div>
    </div>
  );

  return (
    <div style={{ padding: 32, fontFamily: "Inter, sans-serif" }}>
      <h1 style={{ fontFamily:"'Cormorant Garamond',Georgia,serif",
                   color: B, fontSize: 24, marginBottom: 8 }}>
        🔐 Admin Management
      </h1>
      <p style={{ background:"#FFF8E7", border:"1px solid #F0D080",
                  padding:"10px 14px", borderRadius:8,
                  fontSize:13, color:"#7A5C00", marginBottom:24 }}>
        New admins default to password <code>embroideary</code>. Only owners can manage admins.
      </p>

      {/* Add form */}
      <div style={card}>
        <h2 style={cardTitle}>Add New Admin</h2>
        <form onSubmit={add}>
          <div style={{ display:"flex", gap:14, flexWrap:"wrap", marginBottom:14 }}>
            {[["Name","name","text","Full name"],
              ["Email","email","email","admin@example.com"],
              ["Initial Password","password","text","embroideary"]
            ].map(([lbl, key, type, ph]) => (
              <div key={key} style={{ flex:"1 1 180px" }}>
                <label style={lbl_s}>{lbl}</label>
                <input style={inp} type={type} value={form[key]} placeholder={ph}
                  required={key==="email"}
                  onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))} />
              </div>
            ))}
            <div style={{ flex:"1 1 120px" }}>
              <label style={lbl_s}>Role</label>
              <select style={inp} value={form.role}
                onChange={e => setForm(f => ({ ...f, role: e.target.value }))}>
                <option value="staff">Staff</option>
                <option value="owner">Owner</option>
              </select>
            </div>
          </div>
          {msg.text && (
            <p style={{ ...msgS,
              background: msg.type==="ok" ? "#E2EFDA" : "#FCE4D6",
              color:       msg.type==="ok" ? "#2E7D32" : "#C00000" }}>
              {msg.text}
            </p>
          )}
          <button type="submit" style={btn}>+ Add Admin</button>
        </form>
      </div>

      {/* List */}
      <div style={card}>
        <h2 style={cardTitle}>Current Admins ({admins.length})</h2>
        {loading ? <p style={{ color:"#999" }}>Loading…</p> : (
          <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
            <thead>
              <tr>
                {["Name","Email","Role","Status","Actions"].map(h => (
                  <th key={h} style={{ background: B, color:"#FAF7F2",
                                       padding:"9px 12px", textAlign:"left", fontSize:12 }}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {admins.map((a, i) => (
                <tr key={a._id} style={{ background: i%2===0 ? "#FDF6EC" : "#fff" }}>
                  <td style={tdc}>
                    <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                      <div style={{ width:28, height:28, borderRadius:"50%",
                                    background:"#C9847A", display:"flex",
                                    alignItems:"center", justifyContent:"center",
                                    fontWeight:700, color:"#fff", fontSize:12 }}>
                        {(a.name || a.email || "A")[0].toUpperCase()}
                      </div>
                      {a.name || "—"}
                    </div>
                  </td>
                  <td style={tdc}>{a.email}</td>
                  <td style={tdc}>
                    <span style={{ fontWeight:600, color: a.role==="owner" ? B : "#555" }}>
                      {a.role}
                    </span>
                  </td>
                  <td style={tdc}>
                    <span style={{ padding:"3px 10px", borderRadius:20,
                                   fontSize:12, fontWeight:600,
                                   background: a.active ? "#E2EFDA" : "#FCE4D6",
                                   color:      a.active ? "#2E7D32" : "#C00000" }}>
                      {a.active ? "Active" : "Inactive"}
                    </span>
                  </td>
                  <td style={tdc}>
                    {a.email === user?.email
                      ? <span style={{ color:"#aaa", fontSize:12 }}>You</span>
                      : (
                        <div style={{ display:"flex", gap:8 }}>
                          <button onClick={() => toggle(a.email, a.active)} style={abtn}>
                            {a.active ? "Deactivate" : "Reactivate"}
                          </button>
                          <button onClick={() => remove(a.email)}
                            style={{ ...abtn, color:"#C00000" }}>
                            Remove
                          </button>
                        </div>
                      )
                    }
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

const card      = { background:"#fff", borderRadius:12, padding:24,
                    boxShadow:"0 2px 10px rgba(0,0,0,0.07)", marginBottom:24 };
const cardTitle = { fontSize:15, fontWeight:700, color: B, marginBottom:16, marginTop:0 };
const lbl_s     = { display:"block", fontSize:12, fontWeight:600, color: B, marginBottom:4 };
const inp       = { width:"100%", padding:"9px 12px", borderRadius:7,
                    border:"1px solid #ddd", fontSize:13,
                    boxSizing:"border-box", fontFamily:"inherit" };
const btn       = { padding:"10px 22px", background: B, color:"#FAF7F2",
                    border:"none", borderRadius:8, fontSize:13, fontWeight:600, cursor:"pointer" };
const msgS      = { padding:"8px 12px", borderRadius:6, fontSize:13, marginBottom:12 };
const tdc       = { padding:"10px 12px", borderBottom:"1px solid #eee", verticalAlign:"middle" };
const abtn      = { padding:"5px 12px", background:"#f5f5f5", border:"1px solid #ddd",
                    borderRadius:6, fontSize:12, cursor:"pointer", color: B };
